import React, { Component } from 'react';
import Section from './Section.js'
import {reduxForm, Field} from 'redux-form';
import { withRouter } from 'react-router';
import { HotKeys } from "react-hotkeys";
import {FormattedHTMLMessage} from 'react-intl';

import generateValidator from './Validations/generateValidator';
import CustomAlert from '../components/CustomAlert.js';
import RenderField from './RenderField';
import CustomSpinner from './CustomSpinner';
import SaveStepButton from './SaveStepButton';
import withAuthControl from '../auth/Auth.js';
import AttributeOptions from './AttributeOptions.js';
import { WAButton } from './Button.js';

class CAWarrantyForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {},
            initialForm: false,
            resources: [
                'ca_warranty_type'
            ]
        }
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const warranty_type = [{id: 0, name: 'Hipotecaria'}, {id: 1, name: 'Prenda'},{id: 2, name: 'Fianza'}];
        const warranty = (
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                        <AttributeOptions name="ca_warranty_type" defaultValue="Tipo de Garantía" label="Tipo de Garantía" attributeName='warranty_type' attributeOptions={warranty_type} />
                    </div>
                </div>
            </div>
        );

        return (
            <Section className="intro_form">
            <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                    <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                    <FormattedHTMLMessage id="app.step_ca_warranty" description="Warranty"/>
                    <div className="show-desktop">
                        <WAButton phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                        <SaveStepButton/>
                    </div>
                </div>
                <div style={{height:'80px'}}></div>
                <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                    {this.state.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá.... Por favor espere...' /> }
                        <div>
                            <form onSubmit={handleSubmit(this.props.addCAWarrantyType)} className='pvc-form'>
                                {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                                {error && <CustomAlert bsStyle="danger" message={error}/>}
                                    {warranty}
                                <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={submitting}>Continuar</button>
                            </form>
                        </div>
                        <div className="show-mobile">
                            <WAButton phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                          <SaveStepButton/>
                        </div>
                </div>
            </div>
        </Section>
        );
    }
}

CAWarrantyForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'ca_warranty_type', required: true}]);

CAWarrantyForm = reduxForm({
    form: 'CAWarrantyForm', // a unique name for this form
    validate,
})(CAWarrantyForm);

CAWarrantyForm = withRouter(CAWarrantyForm);

CAWarrantyForm = withAuthControl(CAWarrantyForm);

export default CAWarrantyForm;



/** WEBPACK FOOTER **
 ** ./src/components/CAWarrantyForm.js
 **/